import useIsCorpView from "./useIsCorpView"
import { useAppSelector } from "../redux/store"
import { selectBalance } from "../redux/customer"
import { selectChildBalance } from "../redux/childCustomer"

const useCustomerBalance = () => {
  const isCorpView = useIsCorpView()

  const balance = isCorpView
    ? useAppSelector(selectChildBalance)
    : useAppSelector(selectBalance)

  return balance
}

export default useCustomerBalance
